import React, { useState, useEffect } from "react";
import { ContentBodyPerfilAgencia } from '../../components/perfilAgenciaNuevo/ContentBodyPerfilAgencia'
import { MiFooter } from '../../components/footer/MiFooter'
import './PerfilAgencia.css'
import './PerfilAgenciaNuevo.css'
import axios from 'axios';
import { MenuLateralAB } from "../../components/menuLateralAA/MenuLateralAB";
import HeaderHome from "../../components/headerHome/HeaderHome";

export const PerfilAgencia = (props) => {

    /* A hook that is used to change the state of the menu. */
    const [MenuLateralAux, setMenuLateralAux] = useState();

    const chageMenuLateralAux = () => {
        setMenuLateralAux(!MenuLateralAux)
    }
    

    return (
        <>
            <div className='PerfilAgencia'>
                <div className='headerPerfilAgencia'>
                    <HeaderHome 
                        chageMenuLateralAux={chageMenuLateralAux}
                    />
                </div>
                <div className="bodyPerfil-agencia">
                    <ContentBodyPerfilAgencia  
                        MenuLateralAux={MenuLateralAux}
                        chageMenuLateralAux={chageMenuLateralAux}
                    />
                </div>
                <div className='footerPerfilAgencia'>
                    <MiFooter />
                </div>
            </div>
        </>
    )
}
